import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// Connects our App.js (src folder) to index.html (public folder)
// specifically, the element with the id == 'root'
ReactDOM.render(<App />, document.getElementById('root'));




